import { tv } from 'tailwind-variants';

export const answer = tv({
  base: 'border-hairline rounded-md flex items-center justify-center w-11 h-11 inline text-button-color-secondary-default',
  variants: {
    variant: {
      correct:
        'border-feedback-color-success-lighter bg-feedback-color-success-lightest shadow-success',
      incorrect:
        'border-feedback-color-error-lighter bg-feedback-color-error-lightest shadow-error',
      undefined: 'border-mono-color-lighter bg-mono-color-white shadow-level-1',
      discursive: 'border-primary-300 bg-primary-100 shadow-info',
      selected:
        'border-color-brand-primary bg-brand-color-primary-lighter shadow-level-1',
    },
    done: {
      false: 'border-mono-300 bg-white shadow-level-1',
    },
    selected: {
      true: 'border-color-brand-primary',
      false: '',
    },
  },
});

export const answerBadge = tv({
  base: 'w-4 h-4 rounded-circular flex items-center justify-center absolute ml-[30px] mt-[-4px]',
  variants: {
    variant: {
      correct: 'bg-feedback-color-success-lighter',
      incorrect: 'bg-feedback-color-error-lighter',
      undefined: '',
      discursive: '',
      selected: '',
    },
  },
});

export const answerIcon = tv({
  base: 'w-3 h-3',
  variants: {
    variant: {
      correct: 'fill-feedback-color-success-pure',
      incorrect: 'fill-feedback-color-error-pure',
      undefined: '',
      discursive: '',
      selected: '',
    },
  },
});
